export default __webpack_public_path__ + "static/SSSpyView_screenshot-4@mob2x-3fc2f7cd46043f0e934edb3bb2c7d152.webp";